module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('symbol', {
    attrs: {
      "id": "pin-person",
      "viewBox": "0 0 58.69 66.42"
    }
  }, [_c('path', {
    attrs: {
      "d": "M58.69,29.35A29.35,29.35,0,0,0,29.64,0,29.66,29.66,0,0,0,0,29.13,29.34,29.34,0,0,0,19,56.8a14.91,14.91,0,0,1,5.64,3.85,59.73,59.73,0,0,1,4.23,5.49.67.67,0,0,0,1.06,0c1.65-2,3.34-4.21,5.07-6a15,15,0,0,1,5.24-3.57A29.33,29.33,0,0,0,58.69,29.35Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "29.35",
      "cy": "29.53",
      "r": "23.24",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "29.35",
      "cy": "18.74",
      "r": "8.98"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.35,28.53h0A15.33,15.33,0,0,1,44.67,43.85v9.32a0,0,0,0,1,0,0H14a0,0,0,0,1,0,0V43.85A15.33,15.33,0,0,1,29.35,28.53Z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a80bb450","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/decoration/visualization/person_pin.vue
// module id = 677
// module chunks = 0